export const API_URL =
  process.env.REACT_APP_ENV === 'staging' ? 'https://us-central1-meny-stag.cloudfunctions.net/api' : 'https://us-central1-lynked-demo-tryout.cloudfunctions.net/api';
